import JobPostingHelper from './models/JobPostingHelper';

export default { jobPostings: JobPostingHelper };
